<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
  viewBox="0 0 9787 9787"
   xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <path class="fil0" d="M9787 8792c0,550 -445,995 -995,995l-7797 0c-549,0 -995,-445 -995,-995l0 -7797c0,-549 446,-995 995,-995l7797 0c550,0 995,446 995,995l0 7797z"/>
   </g>
   <g id="Vrstva_x0020_1_0">
    <path class="fil1" d="M3007 7094l4612 0c500,0 500,614 0,614l-4612 0c-500,0 -500,-614 0,-614zm5492 614l0 614 -7211 0 0 -614 0 -5987c0,-120 112,-256 210,-256l6792 0c97,0 209,136 209,256l0 5987zm-5492 -1842l4612 0c500,0 500,614 0,614l-4612 0c-500,0 -500,-614 0,-614zm0 -1228l4612 0c500,0 500,614 0,614l-4612 0c-500,0 -500,-614 0,-614zm0 -1228l4612 0c500,0 500,614 0,614l-4612 0c-500,0 -500,-614 0,-614zm0 -1229l4612 0c500,0 500,614 0,614l-4612 0c-500,0 -500,-614 0,-614z"/>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'Gate',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE}
.fil0 {fill:#00A0E3;fill-rule:nonzero}
</style>
